import { ConnectionNames } from "../Contracts";
import { QueryBuilder } from "./Helpers";
import { BaseRESTConnection } from "../Common";
export class TournamentsConnection extends BaseRESTConnection {
    constructor(meta) {
        super(ConnectionNames.tournaments, meta);
    }
    getTournamentDetails(q) {
        return this.applyQuery(QueryBuilder.getTournamentDetails(q));
    }
    onGetTournamentDetails(q, success, error) {
        return this.subscribeToOnStaleData("getTournamentDetails", q, success, error);
    }
    getTournamentWinners(q) {
        return this.applyQuery(QueryBuilder.getTournamentWinners(q));
    }
    getTournaments(q) {
        return this.applyQuery(QueryBuilder.getTournaments(q));
    }
    onGetTournaments(q, success, error) {
        return this.subscribeToOnStaleData("getTournaments", q, success, error);
    }
    getOptInTournaments(q) {
        return this.applyQuery(QueryBuilder.getOptInTournaments(q));
    }
    onGetOptInTournaments(q, success, error) {
        return this.subscribeToOnStaleData("getOptInTournaments", q, success, error);
    }
    optIn(q) {
        return this.applyQuery(QueryBuilder.optIn(q));
    }
    getLeaderboards(q) {
        return this.applyQuery(QueryBuilder.getLeaderboards(q));
    }
    subscribeToOnStaleData(methodKey, query, success, error) {
        if (typeof success !== "function") {
            throw new Error(`Expected the "success" parameter to be a "function" but "${typeof success}" was received`);
        }
        if (typeof error !== "function") {
            throw new Error(`Expected the "error" parameter to be a "function" but "${typeof error}" was received`);
        }
        const handler = () => {
            this[methodKey](query).then(success).catch(e => {
                try {
                    error(e);
                }
                catch (e) {
                    console.error("An exception ocurred inside of an error function. The handler will unsubscribe");
                    this.offStaleData(handler);
                }
            });
        };
        this.onStaleData(handler);
        return () => {
            this.offStaleData(handler);
        };
    }
}
//# sourceMappingURL=TournamentsConnection.js.map